import { ChapterTag, MaskedLine, Reveal } from "@/components/bits";

export default function Nature() {
  return (
    <section className="pb-24 md:pb-36" data-testid="nature-section">
      <div className="relative h-[62vh] min-h-[26rem] overflow-hidden md:h-[78vh]">
        <img
          src="/images/bloom.jpg"
          alt="A year-round calendar of native blooms at Embassy South Reserve — sunbirds, butterflies and bees through the seasons"
          data-testid="bloom-image"
          className="h-full w-full object-cover object-bottom"
        />
      </div>
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <Reveal className="relative z-10 -mt-24 max-w-2xl bg-[#022C22] p-8 md:-mt-44 md:p-14">
          <div data-testid="bloom-card">
            <ChapterTag num="04" label="The Bloomscape" light />
            <h2 className="font-display mt-8 text-3xl font-light leading-[1.08] tracking-tight text-[#F5F1E8] sm:text-4xl lg:text-5xl">
              <MaskedLine inView delay={0.1}>A landscape that was never</MaskedLine>
              <MaskedLine inView delay={0.2}>
                designed <span className="italic text-[#A98B5F]">to look finished.</span>
              </MaskedLine>
            </h2>
            <p className="mt-7 max-w-md text-sm leading-relaxed text-[#F5F5F4]/70 md:text-base">
              Through the year, a different native species comes into flower — January's blooms give
              way to April's, April's to July's. Sunbirds arrive with the early flowers; butterflies
              and bees follow through the warmer months, and by the time the cycle closes, it has
              already begun again.
            </p>
            <div className="mt-10 flex gap-14 border-t border-[#F5F5F4]/15 pt-8">
              <div>
                <div className="font-display text-4xl font-light text-[#A98B5F] md:text-5xl">120+</div>
                <div className="mt-2 text-[10px] uppercase tracking-[0.28em] text-[#F5F5F4]/60">
                  Native species
                </div>
              </div>
              <div>
                <div className="font-display text-4xl font-light text-[#A98B5F] md:text-5xl">12</div>
                <div className="mt-2 text-[10px] uppercase tracking-[0.28em] text-[#F5F5F4]/60">
                  Months in bloom
                </div>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
